import Modal from 'components/global/Modal'
import { Col, Row } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { HundredBookChallengeModule } from 'pages/100-book-challenge'
import React from 'react'

import MaterialButtonBaskets from './MaterialButtonBaskets'

interface Props {
	baskets: HundredBookChallengeModule['leveledLibrary']
	maxBaskets?: number
}

const HundredBookChallenge = ({ baskets, maxBaskets = 8 }: Props) => {
	const [show, setShow] = React.useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const data = useStaticQuery(graphql`
		query {
			contentfulModal(name: { eq: "100 Book Challenge" }) {
				id
				title
				image {
					id
					title
					gatsbyImageData(placeholder: BLURRED)
				}
				description {
					description
				}
			}
		}
	`)

	const title = data.contentfulModal.title
	const description = data.contentfulModal.description.description

	return (
		<React.Fragment>
			<MaterialButtonBaskets onClick={handleShow} title={title} baskets={baskets} max={maxBaskets} />
			<Modal title={title} isOpen={show} handleClose={handleClose} wide>
				<Row>
					<Col>
						<p className="text-lg text-slate-400">{description}</p>
					</Col>
					<Col>
						<div className="flex w-full flex-auto flex-wrap">
							{baskets.map((basket) => {
								return (
									<div className={`${maxBaskets === 8 ? 'w-1/4' : 'w-1/5'}`} key={basket.id}>
										<GatsbyImage image={basket.gatsbyImageData} alt={basket.title} />
									</div>
								)
							})}
						</div>
					</Col>
				</Row>
			</Modal>
		</React.Fragment>
	)
}

export default HundredBookChallenge
